import React from 'react';

export function PriceColumnFormatter(cellContent, row) {
  const getLabelCssClasses = () => {
    return `text-center`;
  };
  const round = (val) => {
    if (val) return Math.round((val + Number.EPSILON) * 100) / 100;
    else return 0.0;
  };
  return (
    <div className={getLabelCssClasses()}>
      {cellContent &&
        round(cellContent)
          .toString()
          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')}
      ₮
    </div>
  );
}
